export default "__VITE_ASSET__Cfp_EPgk__"